import { render, staticRenderFns } from "./BuscadorAsentamientos.vue?vue&type=template&id=6abda2da&"
import script from "./BuscadorAsentamientos.vue?vue&type=script&lang=js&"
export * from "./BuscadorAsentamientos.vue?vue&type=script&lang=js&"
import style0 from "./BuscadorAsentamientos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports